(function () {
  const counters = [];
  const pad2 = n => (n < 10 ? "0" + n : "" + n);
  let tickId = null;

  function ensureTick() {
    if (tickId != null) return;
    const tick = () => {
      const now = Date.now();
      for (let i = 0; i < counters.length; i++) counters[i].update(now);
    };
    tick(); // immediate first render
    tickId = setInterval(tick, 1000);
  }

  function startCountdownFor(counterEl) {
    if (counterEl.__counterInited) return;
    counterEl.__counterInited = true;

    const dateStr = counterEl.dataset.date;
    const restartDaily = String(counterEl.dataset.restartDaily).toLowerCase() === 'true';
    if (!dateStr) return;

    // Cache refs once
    const elDays    = counterEl.querySelector('[data-unit="days"]');
    const elHours   = counterEl.querySelector('[data-unit="hours"]');
    const elMinutes = counterEl.querySelector('[data-unit="minutes"]');
    const elSeconds = counterEl.querySelector('[data-unit="seconds"]');

    // Track last displayed values to avoid unnecessary DOM writes
    const last = { d: null, h: null, m: null, s: null, shown: false };

    let updater;

    if (restartDaily) {
      // ---- Daily reset branch (per-element) ----
      const initialDate = new Date(dateStr);
      const targetHour = initialDate.getUTCHours();
      const targetMinute = initialDate.getUTCMinutes();

      const nextResetMs = (baseNowMs) => {
        const now = new Date(baseNowMs);
        const reset = new Date(now);
        reset.setUTCHours(targetHour, targetMinute, 0, 0);
        if (now < reset) return reset.getTime();
        reset.setUTCDate(reset.getUTCDate() + 1);
        return reset.getTime();
      };

      let targetTs = nextResetMs(Date.now());

      updater = function update(nowMs) {
        if (nowMs >= targetTs) targetTs = nextResetMs(nowMs);
        const distance = targetTs - nowMs;

        const days    = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours   = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        if (days    !== last.d) { elDays.textContent    = pad2(days);    last.d = days; }
        if (hours   !== last.h) { elHours.textContent   = pad2(hours);   last.h = hours; }
        if (minutes !== last.m) { elMinutes.textContent = pad2(minutes); last.m = minutes; }
        if (seconds !== last.s) { elSeconds.textContent = pad2(seconds); last.s = seconds; }

        if (!last.shown) { counterEl.classList.remove('hidden'); last.shown = true; }
      };
    } else {
      // ---- Fixed-deadline branch (per-element) ----
      const deadlineTs = new Date(dateStr).getTime();

      updater = function update(nowMs) {
        const distance = deadlineTs - nowMs;

        const dRaw = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hRaw = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const mRaw = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const sRaw = Math.floor((distance % (1000 * 60)) / 1000);

        const days    = distance >= 0 ? dRaw : 0;
        const hours   = distance >= 0 ? hRaw : 0;
        const minutes = distance >= 0 ? mRaw : 0;
        const seconds = distance >= 0 ? sRaw : 0;

        if (days    !== last.d) { elDays.textContent    = pad2(days);    last.d = days; }
        if (hours   !== last.h) { elHours.textContent   = pad2(hours);   last.h = hours; }
        if (minutes !== last.m) { elMinutes.textContent = pad2(minutes); last.m = minutes; }
        if (seconds !== last.s) { elSeconds.textContent = pad2(seconds); last.s = seconds; }

        if (!last.shown) { counterEl.classList.remove('hidden'); last.shown = true; }

        if (distance < 0) {
          counterEl.classList.add('hidden');
        }
      };
    }

    // Register and ensure ticking
    counters.push({ update: updater });
    ensureTick();
  }

  // Init existing counters immediately
  function initAll() {
    document.querySelectorAll('.counter').forEach(startCountdownFor);
  }
  initAll();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  }

  // Handle counters added later (sections/Ajax)
  const mo = new MutationObserver((muts) => {
    for (const m of muts) {
      for (const node of m.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches?.('.counter')) startCountdownFor(node);
        node.querySelectorAll?.('.counter').forEach(startCountdownFor);
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
